export var AutodiscoveryProcessStatus;
(function (AutodiscoveryProcessStatus) {
    AutodiscoveryProcessStatus["UNSPECIFIED"] = "unspecified";
    AutodiscoveryProcessStatus["PROCESS"] = "progress";
    AutodiscoveryProcessStatus["ERROR"] = "error";
    AutodiscoveryProcessStatus["SUCCESS"] = "success";
})(AutodiscoveryProcessStatus || (AutodiscoveryProcessStatus = {}));
export var FileUploadStatus;
(function (FileUploadStatus) {
    FileUploadStatus["OK"] = "ok";
    FileUploadStatus["ERROR"] = "error";
})(FileUploadStatus || (FileUploadStatus = {}));
//# sourceMappingURL=Autodiscovery.js.map